module.exports = __webpack_public_path__ + "static/img/unit-7.45abfdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyprofilepic/unit-7.jpg
// module id = 8DkS
// module chunks = 51